<script>
import Layout from '@layouts/primary'
import { vehicleMethods, serviceTypeMethods, depotMethods } from '@state/helpers'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewTyreLog',
    meta: [{ name: 'description', content: 'ViewTyreLog' }],
  },
  components: { Layout },
  data() {
    return {
      vehicle: {},
      attributesDesc:[],
      attributesObj: [],
      vehicleLog: {},
      editVehicle: false,
      removeVehicle:false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.vehicleLog = this.$router.history.current.params.vehicleLog;
    // console.log(this.vehicleLog)
  },
  methods: {
    ...vehicleMethods, ...serviceTypeMethods, ...depotMethods,
    update() {
      this.$validator.validateAll()
    },
    submit() {

    },
    clear() {
      this.$validator.reset()
      this.editVehicle = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    defineTyre(num){
      // Define color according to tyres replaced
      let tyres = this.vehicleLog.tyres;
      let tyreClass = "tyre-white";
      for (let i in tyres){
        if(tyres[i] === num){
          tyreClass = "tyre";
        }
      }
      return tyreClass
    }
  }
}
</script>

<template>
  <Layout>
    <VContainer grid-list-md>
      <h2>View Tyre Log</h2>
      <VCard class="v-card-padding top-blue">
        <h3
          v-if="vehicleLog.vehicle"
          class="fixedSpaceVertical"
        >
          <i class="fas fa-truck fixedSpaceHorizontal" /> Vehicle Registration - {{ vehicleLog.vehicle.number_plate }}
        </h3>
        <VLayout
          row
          wrap
          class="client-card"
        >
          <VFlex
            xs12
            sm4
            md5
            lg4
            class="flex"
          >
            <h5><strong>Tyre(s) Replaced</strong></h5>
            <br>
            <div>
              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(1)">
                    <p>1</p>
                  </div>
                </VFlex>

                <VFlex
                  xs8
                  sm8
                  md8
                  lg8
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p>STEER</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(2)">
                    <p>2</p>
                  </div>
                </VFlex>
              </VLayout>

              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(3)">
                    <p>3</p>
                  </div>
                </VFlex>

                <VFlex
                  xs8
                  sm8
                  md8
                  lg8
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p>SECOND STEER</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(4)">
                    <p>4</p>
                  </div>
                </VFlex>
              </VLayout>

              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(5)">
                    <p>5</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(6)">
                    <p>6</p>
                  </div>
                </VFlex>

                <VFlex
                  xs4
                  sm4
                  md4
                  lg4
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p>FIRST DRIVE</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(7)">
                    <p>7</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(8)">
                    <p>8</p>
                  </div>
                </VFlex>
              </VLayout>

              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(9)">
                    <p>9</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(10)">
                    <p>10</p>
                  </div>
                </VFlex>

                <VFlex
                  xs4
                  sm4
                  md4
                  lg4
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p>SECOND DRIVE</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(11)">
                    <p>11</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(12)">
                    <p>12</p>
                  </div>
                </VFlex>
              </VLayout>

              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(13)">
                    <p>13</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(14)">
                    <p>14</p>
                  </div>
                </VFlex>

                <VFlex
                  xs4
                  sm4
                  md4
                  lg4
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p>TRAILER</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(15)">
                    <p>15</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(16)">
                    <p>16</p>
                  </div>
                </VFlex>
              </VLayout>
              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(17)">
                    <p>17</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(18)">
                    <p>18</p>
                  </div>
                </VFlex>

                <VFlex
                  xs4
                  sm4
                  md4
                  lg4
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p />
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(19)">
                    <p>19</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(20)">
                    <p>20</p>
                  </div>
                </VFlex>
              </VLayout>

              <VLayout
                row
                wrap
                align-center
                justify-start
              >
                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(21)">
                    <p>21</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(22)">
                    <p>22</p>
                  </div>
                </VFlex>

                <VFlex
                  xs4
                  sm4
                  md4
                  lg4
                  style="padding-left: 0 !important;"
                >
                  <div class="tyreDesc">
                    <p />
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(23)">
                    <p>23</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md2
                  lg2
                  style="padding-left: 0 !important;"
                >
                  <div :class="defineTyre(24)">
                    <p>24</p>
                  </div>
                </VFlex>
              </VLayout>

            </div>
          </VFlex>

          <VFlex
            xs12
            sm4
            md3
            lg4
            class="flex"
          >
            <h5><strong>Repair Reason(s)</strong></h5>
            <br>
            <VFlex
              v-for="reason in vehicleLog.repair_reasons"
              :key="reason"
              xs12
              style="padding: 0 !important"
            >
              <p><i class="fas fa-check fixedSpaceHorizontal" /> {{ reason }} </p>
            </VFlex>
          </VFlex>

          <VFlex
            xs12
            sm4
            md4
            lg4
            class="flex"
          >
            <h5><strong>Extra Information</strong></h5>
            <br>
            <p v-if="vehicleLog.dateFormat">
              <i class="fas fa-calendar fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Date:
              </strong>
              {{ vehicleLog.dateFormat }}
            </p>
            <p v-if="vehicleLog.tyres">
              <i class="fas fa-wrench fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Number of Tyre(s):
              </strong>
              {{ vehicleLog.tyres.length }}
            </p>
            <p v-if="vehicleLog.mileage">
              <i class="fas fa-info-circle fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Vehicle mileage:
              </strong>
              {{ vehicleLog.mileage }}
            </p>
            <p v-if="vehicleLog.order_number">
              <i class="fas fa-check fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Order Number:
              </strong>
              {{ vehicleLog.mileage }}
            </p>
            <p v-if="vehicleLog.driver">
              <i class="fas fa-user fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Driver:
              </strong>
              {{ vehicleLog.driver.name }}
            </p>
            <p>
              <strong class="subtitleStrong">
                Tyre Fitter Signature
              </strong>
            </p>
            <div id="signatureFitter">
              <img
                :src="vehicleLog.fitter_signature"
              >
            </div>
            <div
              v-if="vehicleLog.additional_comments"
              class="signature-notes"
            >
              <h5>Additional Comments:</h5>
              {{ vehicleLog.additional_comments }}
            </div>
            <VFlex
              v-for="attribute in vehicle.attributes"
              :key="attribute.id"
              xs12
              style="padding: 0 !important"
            >
              <p><i class="fas fa-check fixedSpaceHorizontal" /> {{ attribute.description }} </p>
            </VFlex>
          </VFlex>
        </VLayout>
        <VSpacer />
      </VCard>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

</style>
